// Copyright (c) 2017 Deere & Company

import ClaimForApprovalContributions, {getDefaultState as getContributionsDefaultState} from './claim-for-approval-contributions';
import ClaimForApprovalPricingSummary, {getDefaultState as getPricingDefaultState} from './claim-for-approval-pricing-summary';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import ClaimVsrMessage from './claim-vsr-message';
import OtherInstruction from './other-instruction';
import t from 'tcomb';

const ClaimForApproval = t.struct({
    basisForSettlement: t.String,
    claimCurrency: KeyValuePair,
    claimNumber: t.String,
    commentsToDealer: t.String,
    contributions: t.struct({
        current: ClaimForApprovalContributions,
        custom: ClaimForApprovalContributions,
        selectedContribution: KeyValuePair
    }),
    internalDeereComments: t.String,
    isSpaTypeChangeAllowed: t.Bool,
    notes: t.list(OtherInstruction, 'OtherInstruction'),
    pin: t.String,
    pricingSummary: t.struct({
        list: ClaimForApprovalPricingSummary,
        net: ClaimForApprovalPricingSummary
    }),
    responsibleAccount: Dealer,
    specialAllowanceType: KeyValuePair,
    status: KeyValuePair,
    tabm: t.Bool,
    vsrMessages: t.list(ClaimVsrMessage)
}, {
    name: 'ClaimForApproval',
    strict: true
});

export const getDefaultState = () => new ClaimForApproval({
    basisForSettlement: '',
    claimCurrency: getKeyValuePairDefaultState(),
    claimNumber: '',
    commentsToDealer: '',
    contributions: {
        current: getContributionsDefaultState(),
        custom: getContributionsDefaultState(),
        selectedContribution: getKeyValuePairDefaultState()
    },
    internalDeereComments: '',
    isSpaTypeChangeAllowed: false,
    notes: [],
    pin: '',
    pricingSummary: {
        list: getPricingDefaultState(),
        net: getPricingDefaultState()
    },
    responsibleAccount: getDealerDefaultState(),
    specialAllowanceType: getKeyValuePairDefaultState(),
    status: getKeyValuePairDefaultState(),
    tabm: false,
    vsrMessages: []
});

ClaimForApproval.prototype.vsrErrorMessages = function vsrErrorMessages() {

    const errorMessages = this.vsrMessages.filter(vsrMessage => vsrMessage.type.key === 'E');

    return errorMessages;

};

ClaimForApproval.prototype.vsrWarningMessages = function vsrWarningMessages() {

    const errorMessages = this.vsrMessages.filter(vsrMessage => vsrMessage.type.key === 'W');

    return errorMessages;

};

ClaimForApproval.prototype.vsrInfoMessages = function vsrInfoMessages() {

    const errorMessages = this.vsrMessages.filter(vsrMessage => vsrMessage.type.key === 'I');

    return errorMessages;

};

export default ClaimForApproval;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-for-approval.js